// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { ShiftsAreaRoutes } from '@backoffice-frontend/shifts-api'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'
import { ShiftsAreaId } from './ShiftsAreaId'

import { ShiftsAreaNavigation } from './ShiftsAreaNavigation'

const LazyShiftsComponent = lazy(() => import('./ShiftsArea'))

const ShiftsComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyShiftsComponent />
  </SuspenseLoadingWrapper>
)

export const ShiftsArea = {
  id: ShiftsAreaId,
  requiredRight: BoumRight.AREA_SHIFTS,
  NavigationComponent: ShiftsAreaNavigation,
  route: {
    path: ShiftsAreaRoutes.route,
    component: ShiftsComponent,
  },
}
